import CyberLandingPage from 'views/LandingPage/CyberLandingPage.js'
import SchedulePage from './views/SchedulePage/SchedulePage.js'
import SavedSchedulePage from './views/SavedSchedulePage/SavedSchedulePage.js'
import CyberSpacePage from './views/CyberSpacePage/CyberSpacePage.js'

// @material-ui/icons
import { Computer, DateRange, Home } from '@material-ui/icons'

const routes = [
  {
    path: '/',
    name: 'home',
    component: CyberLandingPage,
    navTitle: 'Home',
    icon: Home,
    showInNav: true
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: SchedulePage,
    navTitle: 'Let\'s Meet',
    icon: DateRange,
    showInNav: true
  },
  {
    path: '/cyberspace',
    name: 'CyberSpace',
    component: CyberSpacePage,
    navTitle: 'CyberSpace',
    icon: Computer,
    showInNav: true
  },
  {
    path: '/schedule/me',
    name: 'My Scheduler',
    component: SavedSchedulePage,
    showInNav: false
  },

]
export default routes
